import { httpAuthRequest } from '@/services'

const state = {
    invitations: null,
    currentInvitation: null,
}

const actions = {
    async getInvitations({ commit }) {
        const response = await httpAuthRequest('get', '/invitations/')
        if (response.success) commit('SET_INVITATIONS', response.data)
    },

    async updateInvitations({ commit }, payload) {
        // Invitee and event must be ids.
        const response = await httpAuthRequest('patch', `/invitations/${payload.id}/`, payload);
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Invitation has been updated successfully' })
            commit('UPDATE_INVITATION', response.data)
        }
        else commit('SET_CREATE_EVENT_ERROR', response.data)
    },

    async addMiscellaneous({ commit }, payload) {
        delete payload.created_at
        delete payload.updated_at
        const response = await httpAuthRequest(
            'patch',
            `/invitations/${payload.id}/`,
            payload)
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Item added successfully' })
        }
        else commit('SET_CREATE_EVENT_ERROR', response.data)
    },

    async deleteInvitation({ commit }, id) {
        const response = await httpAuthRequest('delete', `/invitations/${id}/`)
        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Invitation has been canceled successfully' })
            commit('DELETE_INVITATION', id)
        }
        else commit('SET_CREATE_EVENT_ERROR', response.data)
    },

    async createInvitation({ commit }, payload) {
        const response = await httpAuthRequest(
            'post',
            '/invitations/',
            payload
        )

        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Invitation has been sent!' })
            // commit('SET_INVITATIONS', response.data)
        }

        else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })
    },

    async createInvitationFromEvent({ commit }, payload) {
        const response = await httpAuthRequest(
            'post',
            '/invitations/',
            payload
        )

        if (response.success) {
            commit('SET_ALERT', { type: 'success', message: 'Invitation has been sent!' })
            // commit('ADD_INVITATION_TO_EVENT', payload)
        }

        else commit('SET_ALERT', { type: 'error', message: 'Something went wrong' })
    }
}

const mutations = {
    SET_INVITATIONS(state, invitations) {
        state.invitations = invitations.results
    },

    RESET_INVITATIONS(state) {
        state.invitations = null
    },

    ADD_INVITATION(state, invitation) {
        state.invitations.push(invitation);
    },

    UPDATE_INVITATION(state, invitation) {
        // Filter the old invitation out.
        if (state.invitations) state.invitations = state.invitations.filter(e => e.id != invitation.id)
        state.invitations.push(invitation)
    },

    DELETE_INVITATION(state, id) {
        state.invitations = state.invitations.filter(e => e.id != id)
    },

    RESET_STATE(state) {
        state.invitations = null;
        state.currentInvitation = null;
    },

    SET_CURRENT_INVITATION(state, invitation) {
        state.currentInvitation = invitation
    }
}

export default {
    state,
    actions,
    mutations
}
